'use client';

import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import classNames from 'classnames';
import React from 'react';
import Image from 'next/image';

interface DropdownMenuProps {
    menuItems: {
        name: string;
        title: string;
        href?: string | undefined;
        image?: string | undefined;
        fnct?: () => void;
    }[];
    children: React.ReactNode;
}

const DropdownMenu = (props: DropdownMenuProps) => {
    const { menuItems, children } = props;
    return (
        <Menu as="div" className="relative z-50 text-left">
            <div>
                <Menu.Button className="inline-flex w-full items-center">
                    {children}
                </Menu.Button>
            </div>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <div className="py-0">
                    <Menu.Items className="absolute right-0 z-10 min-w-fit origin-top-right rounded-sm bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        {menuItems?.map(x => (
                            <Menu.Item key={x.name}>
                                {({ active }) => (
                                    <a
                                        className={classNames(
                                            active
                                                ? 'bg-gray-900 text-gray-100'
                                                : 'text-gray-700',
                                            'pl-2 p-6 py-2 text-sm whitespace-nowrap w-full rounded-sm inline-flex items-center',
                                        )}
                                        href={x.href || '#'}
                                        onClick={x.fnct && x.fnct}
                                    >
                                        {x.image && (
                                            <div className="relative w-6 h-6 mr-2">
                                                <Image
                                                    alt={x.title}
                                                    className="rounded-full"
                                                    fill
                                                    sizes="45px"
                                                    src={x.image}
                                                    style={{
                                                        objectFit: 'contain',
                                                    }}
                                                />
                                            </div>
                                        )}{' '}
                                        {x.title}
                                    </a>
                                )}
                            </Menu.Item>
                        ))}
                    </Menu.Items>
                </div>
            </Transition>
        </Menu>
    );
};

export default DropdownMenu;
